export * from '@primeuix/themes/aura/paginator';
export { default } from '@primeuix/themes/aura/paginator';
